import axios from 'axios';

const CancelToken = axios.CancelToken;

export default class RegApi {

  constructor(url) {
    var http = axios.create({
      baseURL: url
    })
    /*     http.interceptors.response.use(
          res => {


            return res.data
          },
          error => {
            return error
          }
        ) */
    this.http = http
  }

  jsonrpc(method, params, token) {
    return this.http({
      url: '',
      method: 'post',
      data: {
        "jsonrpc": "2.0",
        "method": method,
        "params": params,
        "id": 1
      },
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Accept': 'application/json',
      },
      cancelToken: token
    }).then(res => {
      if (res && res.data && res.data.error) {
        return Promise.reject(res.data.error)
      } else {
        return res.data.result
      }
    })
  }

  /**
   * Регистрация номера телефона
   * генерируется смс-код, высылается абоненту
   *
   * @param {String} phone 
   * @param {String} captcha 
   * @param {Boolean} phoneIgnore
   * @returns {Promise}
   */
  phoneReg(phone, captcha, phoneIgnore) {
    return this.jsonrpc('phoneReg', [phone, captcha, phoneIgnore == true ? phoneIgnore : false])
  }

  /**
   * Подтревждение номер телефона
   * создается карта, генерируется пин-код
   * 
   * @param {String} code 
   * @returns {Promise}
   */
  phoneConfirm(code) {
    return this.jsonrpc('phoneConfirm', [code])
  }

  /**
   * Смена пин-кода
   * 
   * @param {String} pin 
   * @returns {Promise}
   */
  changePin(pin) {
    return this.jsonrpc('changePin', [pin])

  }

  /**
   * Авторизация и аутентификация пользователя по специальному FORWIRE токену, который содержится в заголовках ответов
   * 
   * @param {String} forWireToken
   * @returns {Promise}
   */
  authUser(forWireToken) {
    return this.jsonrpc('authUser', [forWireToken])
  }

  /**
   * Привязка услуг 
   * 
   * @param {*} guids 
   * @returns {Promise} объект, чьи пары ключ/значение должны быть переданы в виде query части в url
   */
  wireServices(guids) {
    return this.jsonrpc('wireServices', [guids])
  }

  /**
   * 
   * @param {String} addressSearchString 
   * @returns {Promise} списиок автодополеннения адерса по вееденной строке поиска
   */
  autocomplete(addressSearchString) {
    return this.jsonrpc('autocomplete', [addressSearchString, ''])
  }

  autocompleteCancellable(addressSearchString, token) {
    let source = CancelToken.source();
    return {
      promise: this.jsonrpc('autocomplete', [addressSearchString, ''], source.token),
      cancel: () => {
        source.cancel('canceled')
      }
    }
  }

  /**
   * @param {String} addressSearchString 
   * @returns {Promise} список услуг доступных для подключения по введеной строке поиска
   */
  abonents(addressSearchString) {
    return this.jsonrpc('abonents', [addressSearchString, ''])
  }


  /**
   * @param {String} addressSearchString 
   * @returns {Promise} список услуг доступных для подключения по введеной строке поиска
   */
  abonentsCancellable(addressSearchString) {
    let source = CancelToken.source();
    return {
      promise: this.jsonrpc('abonents', [addressSearchString, ''], source.token),
      cancel: () => {
        source.cancel('canceled')
      }
    }
  }

  /**
   * Сброс текущей сессии, если она была
   * @returns {Promise}
   */
  resetUser() {
    return this.jsonrpc('resetUser')
  }

  /**
   * Пропуск этап привязки услуг при регистрации
   * @returns {Promise}
   */
  skipWire() {
    return this.jsonrpc('skipWire')
  }




  /**
   * Получения информации о пользователе (контакты, настройки и доп.информация для ее отображения)
   * @returns {Promise}
   */
  getUserInfo() {

    return this.jsonrpc('getUserInfo')
  }


  /**
   * Запрос на внесение изменений в настройки
   * 
   * @param {Object} partialSettings ассоциативный массив изменений, которые необходимо внести в настройки
   * @returns {Promise} 
   */
  setSettings(partialSettings) {


    return this.jsonrpc('setSettings', [partialSettings])
  }

  /**
   * Запрос на удаление адреса электронной почты из контактов пользователя
   * @returns {Promise}
   */
  emailDelete() {
    return this.jsonrpc('emailDelete')
  }

  /**
   * Запрос изменение или добавление, в случае отсутсвия, адреса электронной почты к контактам пользователя
   * 
   * @param {String} email новый адрес, на который нужно поменять старое значение
   * @param {String} captcha ответ разганной капчи, если нужно
   * @param {Boolean} ignore указание на то, нужно ли игнорировать предупреждение о том, что вносимый email уже используется другим пользователем
   * @returns {Promise} 
   */
  emailChange(email, captcha, ignore) {
    return this.jsonrpc('emailChange', [email, captcha, ignore === true])
  }

  /**
   * Запрос на подтвеждение смены адреса электронной почты
   * 
   * @param {String} confirmCode проверочный код подтверждения
   * @returns {Promise} 
   */
  emailConfirm(confirmCode) {
    return this.jsonrpc('emailConfirm', [confirmCode])
  }

/*   endOtherSessions() {
    return this.jsonrpc('endOtherSessions')  
  } */





}